<template>
    <div class="num-wrap">
        <img v-for="item in numList" :src="getImg(item)"/>
    </div>
</template>

<script>
    export default {
        name: "v-number",
        props: ['value'],
        data() {
            return {
                imgObj: {
                    "0": require('./NO0.png'),
                    "1": require('./NO1.png'),
                    "2": require('./NO2.png'),
                    "3": require('./NO3.png'),
                    "4": require('./NO4.png'),
                    "5": require('./NO5.png'),
                    "6": require('./NO6.png'),
                    "7": require('./NO7.png'),
                    "8": require('./NO8.png'),
                    "9": require('./NO9.png'),
                    "point": require('./point.png'),
                },
                numList: []
            }
        },
        created() {
            this.numList = String(this.value).split('');
        },
        methods: {
            getImg(str) {
                if (isNaN(parseInt(str))) {
                    return this.imgObj['point']
                } else {
                    return this.imgObj[str]
                }
            }
        },
        watch: {
            value() {
                this.numList = String(this.value).split('');
            }
        }
    }
</script>

<style lang="less" scoped>

</style>